import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ArrowLeft } from '@olxbr/olx-icons/dist/System'

import { RemovePhoneConfirmationTemplate } from '../../templates/RemovePhoneConfirmationTemplate'
import { getMaskedValue } from '../../../util/PhonePattern'
import { breakpoints } from '../../../util/medias'

const ContentWrapper = styled.div`
  max-width: 600px;
  flex: 1;
  flex-direction: column;
  margin: auto;
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) and (max-width: ${breakpoints[
      'tablet'
    ]}px) {
    width: 80vw;
  }
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin: 0 auto;
    justify-content: center;
    margin-left: var(--spacing-2);
    margin-right: var(--spacing-2);
  }
`

const StyledTitle = styled.span.attrs({ className: 'typo-title-large' })`
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-2);
  }
`

const StyledArrow = styled(ArrowLeft)`
  color: var(--color-neutral-130);
`
const ArrowContainer = styled.div`
  cursor: pointer;
  margin-bottom: var(--spacing-4);
`

export const RemovePhoneConfirmationPage = ({
  phone,
  token,
  pincode,
  emails,
  onSuccess,
  onBackClick,
  abTests,
  onAccountCompleteData,
}) => {
  return (
    <ContentWrapper>
      <ArrowContainer onClick={onBackClick}>
        <StyledArrow />
      </ArrowContainer>

      <StyledTitle className="mb-4 block">
        {`Seu telefone ${getMaskedValue(phone).pretty} já está vinculado ${
          emails.length > 1 ? 'às seguintes contas' : 'à seguinte conta'
        }`}
      </StyledTitle>

      <RemovePhoneConfirmationTemplate
        phone={phone}
        pincode={pincode}
        emails={emails}
        onSuccess={onSuccess}
        onCancel={onBackClick}
        abTests={abTests}
        token={token}
        onAccountCompleteData={onAccountCompleteData}
      />
    </ContentWrapper>
  )
}

RemovePhoneConfirmationPage.propTypes = {
  onSuccess: PropTypes.func,
  onBackClick: PropTypes.func,
  phone: PropTypes.string,
  emails: PropTypes.arrayOf(PropTypes.string),
  abTests: PropTypes.string,
  token: PropTypes.string,
  onAccountCompleteData: PropTypes.func,
}
